;(function(){
	try {
		var feedbackFormElem = document.getElementsByClassName('contact-form')[0];
	} catch (e) {

	}
	if (!feedbackFormElem) {
		return;
	}

	feedbackFormElem.addEventListener('submit', contactsFormSubmitHandler);

	Array.prototype.slice.call(
		feedbackFormElem.querySelectorAll('input')
	)
		.forEach(function(item) {
			item.addEventListener('focus', clearError);
		});

	function contactsFormSubmitHandler(event) {
		event.preventDefault();
		var xhr = new XMLHttpRequest();
		xhr.open('post','/feedback/');
		xhr.setRequestHeader('Accept', 'application/json');
		var formData = new FormData(feedbackFormElem);
		xhr.onload = function(data) {
			if (200 === xhr.status) {
				var resultData = JSON.parse(xhr.responseText);
				if (resultData && resultData.status) {
					okPopup();
					resetForm();
				} else {
					if (resultData.error) {
						errorField(resultData.error.toLowerCase(), 'Поле заполнено некорректно.');
					} else if (resultData.errors) {
						for (var i = 0; i < resultData.errors.length; i++) {
							try {
								errorField(resultData.errors[i].field, resultData.errors[i].message);
							} catch (e) {
								console.log(e);
							}

						}
					}

				}

			} else {
				errorPopup(xhr.responseText);
			}
		};
		xhr.onerror = function() {
			errorPopup(xhr.responseText);
		};
		xhr.send(formData);
	}

	function resetForm() {
		feedbackFormElem.reset();
		//region ie не скидывает флаг валидности после операции reset
		feedbackFormElem.elements['name'].value=' ';
		feedbackFormElem.elements['name'].value='';
		feedbackFormElem.elements['name'].classList.add('.form-control_reseted');

		feedbackFormElem.elements['contact'].value=' ';
		feedbackFormElem.elements['contact'].value='';
		feedbackFormElem.elements['contact'].classList.add('.form-control_reseted');

		feedbackFormElem.elements['message'].value=' ';
		feedbackFormElem.elements['message'].value='';
		feedbackFormElem.elements['message'].classList.add('.form-control_reseted');
		//endregion
	}

	document.querySelector('.popup__close').addEventListener('click',hidePopup);

	function clearError(event) {
		event.target.classList.remove('form-control_reseted');//ie
		if (event.target.closest('.form-group').classList.contains('error')) {
			event.target.nextElementSibling.nextElementSibling.innerHTML =
				event.target.nextElementSibling.nextElementSibling.dataset.originalTitle;
			event.target.closest('.form-group').classList.remove('error');
		}
	}

	function popup(text) {
		document.querySelector('.btn-fill_send').style.visibility = 'hidden';
		document.querySelector('.popup').querySelector('.popup__content').innerHTML = text;
		document.querySelector('.popup').classList.add('popup_active');
		startHideTimer();

	}

	function okPopup() {
		var message = 'Ваше сообщение успешно отправлено! В ближайшее время<br/>'
			+ 'с Вами свяжется менеджер';
		popup(message);
	}

	function startHideTimer(secs) {
		secs = secs || 10000;
		setTimeout(hidePopup, secs);
	}

	function hidePopup () {
		document.querySelector('.popup').classList.remove('popup_active');
		setTimeout(function() {
			document.querySelector('.btn-fill_send').style.removeProperty('visibility');
		},550)
	}


	function errorPopup(message) {
		popup(message);
	}

	function errorField(field, text) {
		if (!document.getElementsByName(field)[0].nextElementSibling.nextElementSibling.dataset.originalTitle) {
			document.getElementsByName(field)[0].nextElementSibling.nextElementSibling.dataset.originalTitle =
				document.getElementsByName(field)[0].nextElementSibling.nextElementSibling.innerHTML.trim();
		}
		document.getElementsByName(field)[0].nextElementSibling.nextElementSibling.innerHTML = text;
		document.getElementsByName(field)[0].closest('.form-group').classList.add('error');
	}

	feedbackFormElem.querySelector('.btn-fill_send')
	&& feedbackFormElem.querySelector('.btn-fill_send').addEventListener('click', function(e) {
		var event = document.createEvent('Event');
		event.initEvent('submit',true,true);
		feedbackFormElem.dispatchEvent(event);
		e.preventDefault();
	});



})();



//////////////////
// WEBPACK FOOTER
// ./frontend/js/feedback.js
// module id = 3
// module chunks = 0